import React from "react";
import {
  IoAlertCircleOutline,
  IoCalendarOutline,
  IoCheckmarkCircleOutline,
  IoDownloadOutline,
  IoMegaphoneOutline,
  IoNotificationsOutline,
} from "react-icons/io5";

const getStyleByType = (type) => {
  const normalizedType = String(type || "").toLowerCase();

  if (
    normalizedType.includes("delay") ||
    normalizedType.includes("warning") ||
    normalizedType.includes("alert") ||
    normalizedType.includes("gecikme")
  ) {
    return {
      Icon: IoAlertCircleOutline,
      borderColor: "border-l-red-600",
      iconBgColor: "bg-red-50",
      iconTextColor: "text-red-500",
    };
  }

  if (
    normalizedType.includes("success") ||
    normalizedType.includes("paid") ||
    normalizedType.includes("payment") ||
    normalizedType.includes("odeme")
  ) {
    return {
      Icon: IoCheckmarkCircleOutline,
      borderColor: "border-l-green-600",
      iconBgColor: "bg-green-50",
      iconTextColor: "text-green-500",
    };
  }

  if (
    normalizedType.includes("reminder") ||
    normalizedType.includes("calendar") ||
    normalizedType.includes("installment") ||
    normalizedType.includes("taksit")
  ) {
    return {
      Icon: IoCalendarOutline,
      borderColor: "border-l-blue-600",
      iconBgColor: "bg-blue-50",
      iconTextColor: "text-blue-500",
    };
  }

  if (
    normalizedType.includes("route") ||
    normalizedType.includes("announcement") ||
    normalizedType.includes("duyuru") ||
    normalizedType.includes("guzergah")
  ) {
    return {
      Icon: IoMegaphoneOutline,
      borderColor: "border-l-slate-400",
      iconBgColor: "bg-gray-100",
      iconTextColor: "text-gray-500",
    };
  }

  return {
    Icon: IoNotificationsOutline,
    borderColor: "border-l-blue-500",
    iconBgColor: "bg-blue-50",
    iconTextColor: "text-blue-500",
  };
};

export default function NotificationCard({
  type,
  title,
  description,
  time,
  isRead,
  is_read,
  Icon,
  borderColor,
  iconBgColor,
  iconTextColor,
  buttonText,
  onButtonClick,
  linkText,
  onLinkClick,
  LinkIcon = IoDownloadOutline,
}) {
  const readState = isRead !== undefined ? isRead : is_read;
  const isUnread = readState === false || readState === 0 || readState === "0";

  const defaultStyle = getStyleByType(type);

  const FinalIcon = Icon || defaultStyle.Icon;
  const finalBorderColor = borderColor || defaultStyle.borderColor;
  const finalIconBgColor = iconBgColor || defaultStyle.iconBgColor;
  const finalIconTextColor = iconTextColor || defaultStyle.iconTextColor;

  return (
    <div
      className={`bg-white rounded-2xl p-4 border border-gray-100 border-l-4 ${finalBorderColor} shadow-[0px_2px_8px_rgba(0,0,0,0.015)] flex gap-3.5 relative ${
        isUnread ? "bg-blue-50/20" : ""
      }`}
    >
      <div
        className={`w-13 h-13 rounded-full flex items-center justify-center text-xl flex-shrink-0 ${finalIconBgColor} ${finalIconTextColor}`}
      >
        {FinalIcon && <FinalIcon className="text-3xl" />}
      </div>

      <div className="flex-1 min-w-0 pr-12">
        <div className="flex items-center gap-2">
          {isUnread && (
            <span
              className="w-2.5 h-2.5 rounded-full bg-blue-600 flex-shrink-0"
              title="Okunmadı"
            />
          )}
          <h4 className="font-semibold text-gray-900 truncate">{title}</h4>
        </div>

        <p className="text-gray-600 mt-1 leading-relaxed break-words">
          {description}
        </p>

        {buttonText && (
          <button
            onClick={onButtonClick}
            className="mt-3 bg-[#00306b] hover:bg-[#002452] text-white text-xs font-bold px-4 py-2 rounded-lg shadow-sm cursor-pointer"
          >
            {buttonText}
          </button>
        )}

        {linkText && (
          <button
            onClick={onLinkClick}
            className="mt-3 text-blue-600 hover:text-blue-800 text-xs font-bold flex items-center gap-1 transition-colors outline-none cursor-pointer"
          >
            {LinkIcon && <LinkIcon className="text-lg" />}
            <span className="text-sm">{linkText}</span>
          </button>
        )}
      </div>

      {time && (
        <span className="text-sm font-medium text-gray-400 absolute top-4 right-4">
          {time}
        </span>
      )}
    </div>
  );
}
